import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useApp } from "@/AppContext";
import api, { formatApiErrorDetail } from "@/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPassword() {
  const { t } = useApp();
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    }
  };

  return (
    <div className="min-h-screen ps-grid-bg flex items-center justify-center px-6" data-testid="forgot-page">
      <div className="ps-glow-card rounded-2xl w-full max-w-md p-8">
        <h1 className="font-head text-2xl font-bold text-white mb-6">{t("forgot_password")}</h1>
        {done ? (
          <p data-testid="forgot-confirm" className="text-slate-300 text-sm">
            If that email is registered, a reset link has been sent.
          </p>
        ) : (
          <form onSubmit={submit} className="space-y-5">
            <div>
              <Label className="text-slate-300">{t("email")}</Label>
              <Input
                data-testid="forgot-email-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-1.5 bg-slate-900/70 border-slate-700"
                required
              />
            </div>
            {error && <p className="text-red-400 text-sm">{error}</p>}
            <Button
              data-testid="forgot-submit-btn"
              type="submit"
              className="w-full bg-cyan-500 hover:bg-cyan-400 text-slate-950 font-head font-bold py-6"
            >
              {t("send_reset")}
            </Button>
          </form>
        )}
        <Link to="/login" className="block text-center mt-6 text-sm text-cyan-400 hover:underline">
          {t("back_to_login")}
        </Link>
      </div>
    </div>
  );
}
